export default "__VITE_ASSET__BPSBUYbZ__"